import { render, staticRenderFns } from "./DialogSetSalesTaxRate.vue?vue&type=template&id=d6d13a0c"
import script from "./DialogSetSalesTaxRate.vue?vue&type=script&lang=js"
export * from "./DialogSetSalesTaxRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports